(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("FastTrack",
            {
                url: "/FastTrack",
                component: "fasttrack",
                redirectTo: "FastTrack.Initiate",
                requiredPermissions: [{ AccessObject: "Transaction", ActionType: "Create" }],
                resolve: {
                    transaction: [
                        "transactionApi", "$stateParams", function (transactionApi, $stateParams) {
                            if ($stateParams.transactionId)
                                return transactionApi.get($stateParams.transactionId);
                        }
                    ],
                    transactionGroup: [
                        "userApi", function (userApi) {
                            return userApi.getUserTransactionGroup();
                        }
                    ],
                    logo: [
                        "transactionGroup", "transactionGroupApi", function (transactionGroup, transactionGroupApi) {
                            return transactionGroupApi.getLogo(transactionGroup.Id)
                                .then(function (response) {
                                    return URL.createObjectURL(response);
                                }, function () { return "Images/icomply-logo-light-bg-tm@2x.png" });
                        }
                    ],
                    user: [
                        "userApi", function (userApi) {
                            return userApi.getCurrentUser();
                        }
                    ],
                    disclosures: ["transactionGroupApi", "transactionGroup", "transactionApi", "transaction", "_",
                        function (transactionGroupApi, transactionGroup, transactionApi, transaction, _) {
                            return transaction
                                ? transactionApi.getDisclosures(transaction.Id)
                                : transactionGroupApi.getDisclosures(transactionGroup.Id);
                        }
                    ]                 
                }
            });
    }]);

    app.component("fasttrack",
        {
            templateUrl: "/App/FastTrack/template.html",
            controller: fasttrackController,
            bindings: {
                transaction: "<",
                transactionGroup: "<",
                logo: "<",
                user: "<",
                disclosures: "<"
            }
        });

    fasttrackController.$inject = ["$state", "$mdDialog", "$mdSidenav", "_", "authService", "supportEmailer", "portalSettings", "externalLoading2"];
    function fasttrackController($state, $mdDialog, $mdSidenav, _, authService, supportEmailer, portalSettings, externalLoading2) {
        var $ctrl = this;
      
        ng.extend($ctrl,
            {
                toggleAgentInfo: toggleAgentInfo,
                openEmailer: openEmailer,
                redirectToPortal: redirectToPortal,
                logout: logout
            });

        function toggleAgentInfo() {          
            $mdSidenav("user-info-expand").toggle();
        }

        function logout () {
            authService.logout();
        }

        function openEmailer (event) {
            return supportEmailer.open({
                event: event,
                /*template: "Email template",
                title: "ABC Financial Rejection",
                secondaryTitle: "John Smith: Dave Marble - AEL Bonus Gold",
                to: ["brad.westley@figmarketing.com"],
                subject: "test",
                body: "test email"*/
            });
        }

        function redirectToPortal(url) {

            //TODO, change this to be the auth SSO back to portal.  Url Redirection for now.
            if (!url) url = "";
            var w = window;
            w.document.write(externalLoading2.html);
            var redirectUrl = portalSettings.baseUrl + url;
            w.location.href = redirectUrl;
        }
              
        this.$onInit = function () {};
    };

})(window.app, window.angular);